import { configureFirstIframe } from "../../../utils/util";
import { useEffect } from "react";
import { todayDate } from "../../../common/DateFormatters";

const DonationSummary = ({
  setRequestStep,
  barCode,
  pastDonation,
  loading,
  setLoading,
  translationMap
}) => {
  useEffect(() => {
    const dynamicHeight = pastDonation?.length;
    configureFirstIframe(400, dynamicHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateConvert = (dateString) => {
    const [day, month, year] = dateString.split("-");
    const date = new Date(`${year}-${month}-${day}`);
    if (isNaN(date)) {
      throw new Error(`Invalid date: ${dateString}`);
    }
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
  };

  const convertToAmPm = (time) => {
    const [hour, minute] = time.split(":").map(Number);
    const amPm = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12;
    return `${adjustedHour.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")} ${amPm}`;
  };

  return (
    <>
      <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
        <div className="container customContainer">
          <div className="Title_Inner_Box">
            <h6 className="MainTitleOne">{translationMap?.donationSummary}</h6>
          </div>
          <div className="cover_inner_wrapper">
            <div className="cover_main_box1">
              {barCode ?
              <>
                  <div className="donation_form_title_box">
                    <p className="Gray_Title">
                      {translationMap?.upcomingDonations}
                    </p>
                  </div>
                  <div className="blood_donation_summary_box">
                    <div className="bd_summary_box bd_summary_box2">
                      <div className="bd_summary_text_box">
                        <p className="date_text" style={{ direction: "ltr" }}>
                          {todayDate()}
                        </p>
                        <p className="Gray_Title bottom_text bottom_text_italic">
                          {translationMap?.codeValidToday}
                        </p>
                      </div>
                      <div className="bd_summary_icon_box">
                        <img
                        src={`data:image/png;base64,${barCode}`}
                        alt="Displaying barcode" />
                      
                      </div>
                    </div>
                  </div>
                </> :
              null}

              {pastDonation != null &&
              <>
                  <div className="donation_form_title_box">
                    <p className="Gray_Title">
                      {translationMap?.pastDonations}
                    </p>
                  </div>
                  <div className="blood_donation_summary_box">
                    {pastDonation && pastDonation.length > 0 ?
                  pastDonation.map((item, index) => {
                    return (
                      <div className="bd_summary_box" key={index}>
                            <div className="bd_summary_icon_box">
                              <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            
                                <path
                              d="M28.3334 20.3327C28.3334 24.751 24.7517 28.3327 20.3334 28.3327C15.9151 28.3327 12.3334 24.751 12.3334 20.3327C12.3334 14.5811 20.3334 1.66602 20.3334 1.66602C20.3334 1.66602 28.3334 14.5811 28.3334 20.3327Z"
                              stroke="#002F70"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                            
                                <path
                              d="M9.66675 10.9993C9.66675 13.2085 7.87589 14.9993 5.66675 14.9993C3.45761 14.9993 1.66675 13.2085 1.66675 10.9993C1.66675 8.12354 5.66675 1.66602 5.66675 1.66602C5.66675 1.66602 9.66675 8.12354 9.66675 10.9993Z"
                              stroke="#002F70"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                            
                              </svg>
                            </div>
                            <div className="bd_summary_text_box">
                              <p className="date_text" style={{ direction: "ltr" }}>
                                {dateConvert(item?.date)}
                                <span style={{ direction: "ltr" }}>{convertToAmPm(item?.time)}</span>
                              </p>
                              <div className="bd_title">
                                <h6 className="Gray_Title bottom_text">
                                  {translationMap?.donation} #{index + 1}
                                </h6>
                              </div>
                              <p className="Gray_Title bottom_text">
                                {item.location}
                              </p>
                            </div>
                          </div>);

                  }) :

                  <div className="Info_Note_Box">
                        <span className="icon_box">
                          <i className="material-symbols-outlined">info</i>
                        </span>
                        <div className="content_box">
                          <p>{translationMap?.noPastDonationsText}</p>
                        </div>
                      </div>
                  }
                  </div>
                </>
              }

              <div className="section_common_box">
                <span>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    className="bluetrans_btn_link"
                    onClick={() => {
                      setRequestStep(-1);
                      window.parent.scrollTo(0, 0);
                    }}>
                    
                    {translationMap?.backToDammi}
                  </a>
                </span>
              </div>
            </div>
            <div className="cover_main_box2"></div>
          </div>
        </div>
      </section>
    </>);

};

export default DonationSummary;